import BillingPagination from "./BillingPagination";
import BillingStateCard from "./BillingStateCard";
import "./BillingDataTable.css";

const BillingDataTable = ({
  columns,
  rows = [],
  keyExtractor,
  isLoading,
  errorMessage,
  emptyTitle,
  emptyMessage,
  emptyActionLabel,
  onEmptyAction,
  errorActionLabel,
  onErrorAction,
  currentPage,
  totalPages,
  onPageChange,
  renderRowActions,
}) => {
  const hasActions = Boolean(renderRowActions);
  const colspan = columns.length + (hasActions ? 1 : 0);

  if (isLoading) {
    return (
      <BillingStateCard
        variant="loading"
        title="Loading records"
        message="Fetching the latest billing data."
      />
    );
  }

  if (errorMessage) {
    return (
      <BillingStateCard
        variant="error"
        title="Something went wrong"
        message={errorMessage}
        actionLabel={errorActionLabel}
        onAction={onErrorAction}
      />
    );
  }

  if (!rows.length) {
    return (
      <BillingStateCard
        title={emptyTitle}
        message={emptyMessage}
        actionLabel={emptyActionLabel}
        onAction={onEmptyAction}
      />
    );
  }

  return (
    <section className="billing-data-table">
      <div className="billing-data-table__scroll">
        <table className="billing-data-table__table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key || column.header}>{column.header}</th>
              ))}
              {hasActions ? <th>Actions</th> : null}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={keyExtractor(row, rowIndex)}>
                {columns.map((column) => (
                  <td
                    key={column.key || column.header}
                    data-label={column.header}
                    className={column.cellClassName || ""}
                  >
                    {column.render ? row && column.render(row, rowIndex) : row[column.key]}
                  </td>
                ))}
                {hasActions ? (
                  <td
                    className="billing-data-table__actions-cell"
                    data-label="Actions"
                  >
                    {renderRowActions(row, rowIndex)}
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
          {rows.length === 0 ? (
            <tfoot>
              <tr>
                <td colSpan={colspan}>No results found.</td>
              </tr>
            </tfoot>
          ) : null}
        </table>
      </div>

      <BillingPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </section>
  );
};

export default BillingDataTable;
